import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 3fr 2fr 3fr 3fr 3fr 1fr 1fr;
  column-gap: 16px;
  padding: 0 24px;
`;

export const Divider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 11;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const Header = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 75px;
  border-right: 1px solid ${({ theme }) => theme.colors.grey003};
  padding-right: 15px;
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 68px;

  & > * + * {
    margin-inline-start: 6px;
  }
`;

export const ItemLink = styled(Link)`
  text-decoration: none;
`;

export const ItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const CptCodeText = styled(ItemText)`
  color: ${({ theme, copied }) => (copied ? theme.colors.greenMain : theme.colors.black)};
  font-weight: ${({ copied }) => copied && 'bold'};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.blueMain};
  }
`;

export const ItemStatusText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme, isActive }) => (isActive ? theme.colors.greenMain : theme.colors.redMain)};
`;

export const ItemSubText = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemBtn = styled(typography.BodyTextTwoRegularTypography)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;

  &:before {
    content: ${({ icon }) => icon};
    font-family: icomoon;
    font-size: 18px;
  }
`;

export const TruncatedTextWrapper = styled.div`
  max-height: calc(20px * 3);
  overflow: hidden;
  padding: 0;
  margin: 0;
  line-height: 20px;
`;

export const MoreButton = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.blueMain};
  cursor: pointer;
`;

export const MoreTextWrapper = styled.div`
  width: 95%;
  padding: 15px;
`;

export const PreparationList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

export const PreparationListItem = styled.li`
  text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
  font-size: 13px;
  &::before {
    content: '• ';
  }
`;

export const ShowAlternativeButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.blueMain};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: start;
  padding: 0;
  margin-top: 4px;
  &:hover {
    color: ${({ theme }) => theme.colors.blueDark};
  }
`;
